import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=2bbb1082&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=2bbb1082&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb1082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbb1082')) {
      api.createRecord('2bbb1082', component.options)
    } else {
      api.reload('2bbb1082', component.options)
    }
    module.hot.accept("./Update.vue?vue&type=template&id=2bbb1082&scoped=true", function () {
      api.rerender('2bbb1082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/Update.vue"
export default component.exports